import Downloads from './Downloads'

export default Downloads
